import React, { Component } from "react";
import { withStyles } from "@material-ui/core";
import Divider from "@material-ui/core/Divider";
import Paper from "@material-ui/core/Paper";
import {
  TableContainer,
  Table,
  TableRow,
  TableCell,
  TableBody,
} from "@material-ui/core";

import EmptyLogo from "../../../../Assets/Images/Oops.png";
import Header from "../../../../Component/NavBar/User/Header/Header";
import Footer from "../../../../Component/NavBar/User/Footer/Footer";
import { connect } from "react-redux";
import Axios from "axios";
import { url } from "../../../../config/config";
import moment from "moment";
import CustomTableHead from "../../../../Component/Table/CustomTableHead/CustomTableHead";
import CustomTableFooter from "../../../../Component/Table/CutomTableFooter/CustomTableFooter";
import CustomLoader from "../../../../Component/CustomLoader/CustomLoader";
import CustomEmptyMessage from "../../../../Component/CustomEmptyMessage/CustomEmptyMessage";
import { useStyles } from "./MyRentedBooks.css";
import MobileMyRentedBooks from "./MobileMyRentedBooks/MobileMyRentedBooks";

class MyRentedBooks extends Component {
  constructor(props) {
    super(props);
    this.state = {
      page: 0,
      rowsPerPage: 5,
      column: [
        {
          name: "S.N.",
        },
        {
          name: "Book Title",
        },
        {
          name: "Rented For",
        },
        {
          name: "Rented Date",
        },
        {
          name: "Expired Date",
        },
        {
          name: "Order Id",
        },
        {
          name: "Pay Via",
        },
      ],
      rentBooks: [],
      bookDetails: [],
      isEmpty: false,
    };
  }

  componentDidMount() {
    this.getRentedBooks(this.props.userToken);
  }

  getRentedBooks = async (userToken) => {
    const response = await Axios.get(`${url}/api/rent/myrents`, {
      headers: {
        "x-auth-token": userToken,
      },
    });
    console.log(response.data);
    if (response.data.length !== 0) {
      response.data.map(async (rent) => {
        const response2 = await Axios.get(`${url}/api/books/${rent.bookId}`);
        this.setState({
          bookDetails: [...this.state.bookDetails, response2.data],
        });
      });
      this.setState({
        rentBooks: response.data,
        isEmpty: false,
      });
    } else {
      this.setState({
        rentBooks: [],
        bookDetails: [],
        isEmpty: true,
      });
    }
  };

  getBookTitle = (bookId) => {
    let filter = this.state.bookDetails.find((book) => book._id === bookId);
    return filter && filter.title;
  };

  handlePage = (e, newPage) => {
    this.setState({
      page: newPage,
    });
  };

  handleRowsPerPage = (e) => {
    this.setState({
      rowsPerPage: +e.target.value,
      page: 0,
    });
  };

  render() {
    const { classes } = this.props;
    const { page, rowsPerPage } = this.state;
    return (
      <div>
        <Header />
        {this.state.rentBooks.length !== 0 ? (
          <div className={classes.root}>
            <div
              style={{
                fontSize: 30,
                display: "flex",
                justifyContent: "center",
                fontWeight: "bold",
              }}
            >
              My Rented Books
            </div>
            <Divider />
            <br />
            <Paper className={classes.sectionDesktop}>
              <TableContainer>
                <Table>
                  <CustomTableHead column={this.state.column} />

                  <TableBody>
                    {this.state.rentBooks
                      .slice(
                        page * rowsPerPage,
                        page * rowsPerPage + rowsPerPage
                      )
                      .map((rent, index) => (
                        <TableRow
                          key={index}
                          onClick={() =>
                            this.props.history.push(
                              `/books/details/${rent.bookId}`
                            )
                          }
                          className={classes.tablerow}
                        >
                          <TableCell align="center">{index + 1}</TableCell>
                          <TableCell align="center">
                            {this.getBookTitle(rent.bookId)}
                          </TableCell>
                          <TableCell align="center">
                            {rent.rentedDays} days
                          </TableCell>
                          <TableCell align="center">
                            {moment(rent.createdAt).format("LLLL")}
                          </TableCell>
                          <TableCell align="center">
                            {moment(rent.createdAt)
                              .add(rent.rentedDays, "days")
                              .format("LLLL")}
                          </TableCell>
                          <TableCell align="center">{rent.orderId}</TableCell>
                          <TableCell align="center">{rent.payVia}</TableCell>
                        </TableRow>
                      ))}
                  </TableBody>

                  <CustomTableFooter
                    count={this.state.rentBooks.length}
                    rowsPerPage={this.state.rowsPerPage}
                    page={this.state.page}
                    onChangePage={this.handlePage}
                    onChangeRowsPerPage={this.handleRowsPerPage}
                  />
                </Table>
              </TableContainer>
            </Paper>

            <div className={classes.sectionMobile}>
              <MobileMyRentedBooks
                books={this.state.rentBooks}
                getBookTitle={this.getBookTitle}
              />
            </div>
          </div>
        ) : this.state.isEmpty === true ? (
          <CustomEmptyMessage
            button={true}
            message="No any books has been rented by you."
            buttonLabel="Start Renting"
            buttonUrl={() => this.props.history.push("/books")}
            image={EmptyLogo}
          />
        ) : (
          <CustomLoader />
        )}
        <Footer />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    userToken: state.UserReducer.token,
  };
};

export default connect(
  mapStateToProps,
  null
)(withStyles(useStyles)(MyRentedBooks));
